import React, { forwardRef } from 'react';
// @ts-ignore
import { Transition } from 'react-transition-group';


type FadeTransitionProps = {
  isOpen: boolean,
  children: React.ReactNode,
  enterDuration?: number,
  exitDuration?: number,
  enterDelay?: number,
  exitDelay?: number,
  className?: string,
};

const FadeTransition: React.FC<React.PropsWithChildren<FadeTransitionProps>> = forwardRef(({
  isOpen,
  children,
  enterDuration = 0,
  exitDuration = 0,
  enterDelay = 0,
  exitDelay = 0,
  className,
}, ref: any) => {
  const defaultStyle = {
    opacity: 0,
  };

  const transitionStyles = {
    entering: {
      opacity: 1,
      transition: `opacity ${enterDuration}ms linear ${enterDelay}ms`,
    },
    entered: {
      opacity: 1,
    },
    exiting: {
      opacity: 0,
      transition: `opacity ${exitDuration}ms linear ${exitDelay}ms`,
    },
    exited: {
      opacity: 0,
    },
  };

  return (
    <Transition
      in={isOpen}
      timeout={{
        enter: (enterDuration + enterDelay),
        exit: (exitDuration + exitDelay),
      }}
    >
      {(state: ('entering' | 'entered' | 'exiting' | 'exited')) => (
        <div
          ref={ref}
          className={className || ''}
          style={{
            ...defaultStyle,
            ...transitionStyles[state],
          }}
        >
          {children}
        </div>
      )}
    </Transition>
  );
});

export default FadeTransition;
